module.exports = __webpack_public_path__ + "img/watermark-resort-residences-2.9a4bf325.jpg";